import { createContext } from 'react';
const FirebaseAuthContext = createContext(null);
export default FirebaseAuthContext;
